// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__bfPhv","contact":"style_contact__GaDJj","mainContainer":"style_mainContainer__dz30U","title":"style_title__CY69B","btnGrad":"style_btnGrad___BH__"};